import React, { useState, useContext } from 'react';
import Departments from 'models/departments';
import Logo from '../Logo';
import DepartmentBox from '../DepartmentBox/DepartmentBox';
import { Desktop, Mobile } from '../MediaQuery';
import HeaderWrapper from './styled/HeaderWrapper';
import ActionLinks from './ActionLinks/ActionLinks';
import Hamburger from './mobile/Hamburger';
import MagnifyingGlass from './mobile/MagnifyingGlass';
import SearchBox from '../SearchBox/SearchBox';
import { ShoppingBag, ShoppingBagText } from './styled/ShoppingBag';
import { LeftColumn, LogoRow, NavigationRow, RightColumn } from './styled/HeaderRows';
import NavigationMenuDesktop from '../NavigationMenu/desktop/NavigationMenuDesktop';
import NavigationMenuMobile from '../NavigationMenu/mobile/NavigationMenuMobile';
import NavigationMenuUnderlay from '../NavigationMenu/mobile/styled/NavigationMenuUnderlay';
import CloseNavigationMenu from '../NavigationMenu/mobile/styled/CloseNavigationMenu';
import { DESIGNERS_LIST_PAGE } from '../../helpers/pageHelper';
import { brandsUrl, cart } from '../../helpers/routes';
import ShippingCountry from './ShippingCountry/ShippingCountry';
import { useAppContext } from '../../store/appContext';
import { cartItemsContext } from '../../store/cartItemsContext';
import { useUrlBuilder } from '../../hooks/useUrlBuilder';
import { NewsletterModalButton } from '../NewsletterModalButton/NewsletterModalButton';

const Header = ({ changeShippingVisibility, isShippingSelectorVisible }) => {
  const { department: departmentContext, currPage } = useAppContext();
  const { withCDN, localized } = useUrlBuilder();
  const { numCartItems } = useContext(cartItemsContext);

  const [showMobileNavigationMenu, setShowMobileNavigationMenu] = useState(false);
  const [department, setDepartment] = useState(Departments.getInternalName(departmentContext));
  const [initialDepartment] = useState(Departments.getInternalName(departmentContext));
  const [resetDepartment, setResetDepartment] = useState(false);
  const [searchBarVisible, setSearchBarVisible] = useState(false);

  const toggleNavigationMenu = () => {
    setShowMobileNavigationMenu(!showMobileNavigationMenu);
    setSearchBarVisible(false);
  };

  const getDepartmentLink = dep => {
    if (currPage === DESIGNERS_LIST_PAGE) {
      return localized(`${brandsUrl}/${dep}/`);
    }
    return localized(`/${dep}/`);
  };

  return (
    <div onMouseEnter={() => setResetDepartment(false)} onMouseLeave={() => setResetDepartment(true)}>
      <Mobile>
        <NavigationMenuUnderlay open={showMobileNavigationMenu} />
        <NavigationMenuMobile
          changeShippingVisibility={changeShippingVisibility}
          department={department}
          getDepartmentLink={getDepartmentLink}
          isOpen={showMobileNavigationMenu}
          toggle={toggleNavigationMenu}
          handleClickDepartment={setDepartment}
          initialDepartment={initialDepartment}
        />
        <CloseNavigationMenu
          onClick={toggleNavigationMenu}
          src={withCDN('mkt/icon/x_grey.png')}
          visible={showMobileNavigationMenu}
        />
        {searchBarVisible && <SearchBox hideSearchBox={() => setSearchBarVisible(false)} mobileSubmit />}
        <ShippingCountry
          changeShippingVisibility={changeShippingVisibility}
          isShippingSelectorVisible={isShippingSelectorVisible}
        />
      </Mobile>
      <HeaderWrapper>
        <div>
          <LogoRow>
            <LeftColumn>
              <Mobile>
                <Hamburger
                  data-cy="navigation-menu"
                  onClick={toggleNavigationMenu}
                  src={withCDN('mkt/header_mobile/hamburger.svg')}
                />
              </Mobile>
              <Desktop>
                <NewsletterModalButton header />
              </Desktop>
            </LeftColumn>

            <Logo />

            <RightColumn>
              <Desktop>
                <div style={{ display: 'flex', marginTop: '10px' }}>
                  <ShippingCountry
                    changeShippingVisibility={changeShippingVisibility}
                    isShippingSelectorVisible={isShippingSelectorVisible}
                  />
                  <ActionLinks />
                </div>
              </Desktop>
              <Mobile>
                <MagnifyingGlass
                  data-cy="image-search-open"
                  src={withCDN('mkt/header/magnifying_glass.svg')}
                  onClick={() => setSearchBarVisible(!searchBarVisible)}
                />
              </Mobile>
              <ShoppingBag href={localized(cart)}>
                <ShoppingBagText data-cy="shopping-bag-cart-num-items">{numCartItems || 0}</ShoppingBagText>
              </ShoppingBag>
            </RightColumn>
          </LogoRow>

          <Desktop>
            <NavigationRow marginTop="30px">
              <DepartmentBox
                context="nav"
                resetDepartment={resetDepartment}
                initialDepartment={initialDepartment}
                department={department}
                handleHover={setDepartment}
                handleClick={selectedDepartment => {
                  window.location = getDepartmentLink(selectedDepartment);
                }}
                getDepartmentLink={getDepartmentLink}
              />
              <div style={{ flex: 1 }} />
              <SearchBox menuDepartment={department} />
            </NavigationRow>
            <NavigationRow marginTop="25px">
              <NavigationMenuDesktop department={department} hoverShown={() => {} /* setShowsDepartment(false) */} />
            </NavigationRow>
          </Desktop>
        </div>
      </HeaderWrapper>
    </div>
  );
};

export default Header;
